import { render, staticRenderFns } from "./ConfiguracaoGerentesTerritoriais.vue?vue&type=template&id=3b1b0dea&lang=pug"
import script from "./ConfiguracaoGerentesTerritoriais.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoGerentesTerritoriais.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoGerentesTerritoriais.vue?vue&type=style&index=0&id=3b1b0dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports